import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import LaporanOperasionalService from '../../services/laporanOperasionalServices';
import { clearAuth } from 'store/auth';

export const generateReport = createAsyncThunk('laporanOperasional/generateReport', async ({ cabangId, month, year }, thunkAPI) => {
  try {
    const response = await LaporanOperasionalService.generateReport(cabangId, month, year);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = {
  isLoading: false,
  report: null,
  error: null
};

const laporanOperasionalSlice = createSlice({
  name: 'laporanOperasional',
  initialState,
  reducers: {
    clearReport: (state) => {
      state.report = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateReport.pending, (state) => {
        state.isLoading = true;
        state.report = null;
      })
      .addCase(generateReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.report = action.payload;
      })
      .addCase(generateReport.rejected, (state) => {
        state.isLoading = false;
        state.report = null;
      });
  }
});

export const { clearReport } = laporanOperasionalSlice.actions;
const { reducer } = laporanOperasionalSlice;
export default reducer;

